import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const changeLocationTextFilter = (value) => ({
  'type': ActionTypes.CHANGE_LOCATION_TEXT_FILTER,
  'payload': value,
});

export const changeClassificationTextFilter = (value) => ({
  'type': ActionTypes.CHANGE_CLASSIFICATION_TEXT_FILTER,
  'payload': value,
});

export const fetchPartsList = (parameters, limit = 20, page = 0) => {
  const itemsCount = `&limit=${limit}`;
  const offset = `&offset=${page * limit}`;
  const code = parameters.code ? `&code=${parameters.code}` : '';
  const description = parameters.name ? `&name=${parameters.name}` : '';
  const location = parameters.location ? `&location=${parameters.location}` : '';
  const classification = parameters.classification ?
    `&classification=${parameters.classification}` : '';
  const allFilters = `${code}${description}${location}${classification}${itemsCount}${offset}`;

  return apiActionCreator({
    'endpoint': `/parts?${allFilters}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_PARTS_LIST,
      ActionTypes.FETCHED_PARTS_LIST,
      [
        ActionTypes.FETCHED_PARTS_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const downloadPartsList = (parameters = {}) => {
  const allFilters = getUrlParameters(parameters);
  
  return apiActionCreator({
    'endpoint': `/parts/excel${allFilters}`,
    'authenticated': true,
    'types': [
      ActionTypes.DOWNLOADING_PARTS_LIST,
      ActionTypes.DOWNLOADED_PARTS_LIST,
      [
        ActionTypes.DOWNLOADED_PARTS_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const generatePartDataSheet = (partno) => apiActionCreator({
  'endpoint': `/parts/part-data-sheet/${partno}`,
  'authenticated': true,
  'types': [
    ActionTypes.GENERATING_DATA_SHEET,
    ActionTypes.GENERATED_DATA_SHEET,
    [
      ActionTypes.GENERATED_DATA_SHEET_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchWarehouseStockDetail = (code) => apiActionCreator({
  'endpoint': `/parts/${code}/warehouse-stock`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WAREHOUSE_STOCK_DETAIL,
    ActionTypes.FETCHED_WAREHOUSE_STOCK_DETAIL,
    [
      ActionTypes.FETCHED_WAREHOUSE_STOCK_DETAIL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const clearDataSheetUrl = () => ({
  'type': ActionTypes.CLEAR_DATA_SHEET_URL,
});

// modals
export const fetchBinningPendingDetail = (code) => apiActionCreator({
  'endpoint': `/parts/${code}/bin-pending`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_BINNING_PENDING_DETAIL,
    ActionTypes.FETCHED_BINNING_PENDING_DETAIL,
    [
      ActionTypes.FETCHED_BINNING_PENDING_DETAIL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchInvoicesConfirmedDetail = (code, invoiceCode) => apiActionCreator({
  'endpoint': `/parts/${code}/invoices/confirmed/${invoiceCode}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_INVOICES_CONFIRMED_DETAIL,
    ActionTypes.FETCHED_INVOICES_CONFIRMED_DETAIL,
    [
      ActionTypes.FETCHED_INVOICES_CONFIRMED_DETAIL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchReserveDetailCode = (code) => {
  return apiActionCreator({
    'endpoint': `/parts/analysis/${code}/reserve`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_RESERVE_DETAIL,
      ActionTypes.FETCHED_RESERVE_DETAIL,
      [
        ActionTypes.FETCHED_RESERVE_DETAIL_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};
